import Swal from "sweetalert2";

// Swal ที่ตั้งค่า theme ของโปรเจกต์ไว้แล้ว API เหมือนเดิมทุกอย่าง (Swal.fire({...}))
const appSwal = Swal.mixin({
  confirmButtonColor: "#053075",
  cancelButtonColor: "#8c8c8c",
  confirmButtonText: "ตกลง",
  cancelButtonText: "ยกเลิก",
  customClass: {
    popup: "app-swal-popup",
    title: "app-swal-title",
    htmlContainer: "app-swal-html",
    confirmButton: "app-swal-btn",
    cancelButton: "app-swal-btn",
  },
});

export default appSwal;